import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import {
  Evolution,
  EvolutionItem,
  Intervention,
  Patient,
  Reference,
} from "@/src/data/allTypes";
import { evolutionItemTypes } from "@/src/data/data";
import { CONFIG, USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId, uid } from "@/src/utils/utils";
import { Input } from "@/src/components/universalInput";
import { ReferenceFieldsForm } from "../fields/referenceFieldsForm";
import { ReferenceChoiceList } from "../admin/referentiel/referenceChoiceList";

export default async function openEvolutionStandardForm<
  T extends EvolutionItem
>({
  item,
  patient,
  onConfirm,
}: {
  item: T;
  patient: Patient;
  onConfirm: (item: T) => void;
}) {
  let type = item.type;

  let typeInfo = evolutionItemTypes[type];
  let table = typeInfo.table;

  let formulaires: (Reference | null | undefined)[] = [];
  let speciality = USER.get()?.speciality;
  if (type == "evolution") formulaires = speciality?.evolutionFormulaires || [];
  if (type == "initialExamination")
    formulaires = speciality?.initialExaminationFormulaires || [];
  if (type == "shift") formulaires = speciality?.shiftFormulaires || [];

  let reference: Reference | null | undefined = (item as Intervention)
    .reference;
  if (formulaires.length == 1) reference = formulaires[0];

  if (type == "ventilation")
    reference = await apiFetch("references", "loadOne", {
      referenceId: getItemId(CONFIG.get()?.ventilationForm),
    });

  if (type == "anesthesiologyConsultation")
    reference = await apiFetch("references", "loadOne", {
      referenceId: getItemId(CONFIG.get()?.anesthesiologyConsultationForm),
    });
    
  if (type == "anesthesiologySummary")
    reference = await apiFetch("references", "loadOne", {
      referenceId: getItemId(CONFIG.get()?.anesthesiologySummaryForm),
    });

  console.log("formulaires", formulaires);
  if (formulaires.length > 1) {
    await openDrawer({
      id: "referenceChoiceDrawer",
      title: "Choisir un formulaire",
      content: (
        <ReferenceChoiceList
          current={formulaires}
          allReferences={formulaires}
          categories={[]}
          onSelect={(newReference) => {
            closeDrawer("referenceChoiceDrawer");
            reference = newReference;
          }}
        />
      ),
    });
  }

  await openDrawer({
    id: "historyElementDrawer",
    title: typeInfo.name,
    additionalClasses: ["medium"],
    content: (
      <div className="c1 gap10">
        {reference != null && (
          <ReferenceFieldsForm
            patient={patient}
            currentAnswers={
              (item as Evolution).refAnswer?.fieldAnswers ||
              (item as Intervention).content?.fieldAnswers ||
              []
            }
            reference={reference}
            onChange={(newValue) => {
              (item as Evolution).refAnswer ||= {
                creator: getUserId(),
                reference: getItemId(reference),
                fieldAnswers: [],
                patient: getItemId(patient),
              };
              (item as Evolution).refAnswer!.fieldAnswers = newValue;
            }}
          ></ReferenceFieldsForm>
        )}

        <Input
          name="Observation"
          value={item.notes}
          type="htmlarea"
          rows={10}
          placeholder="Champs de texte libre..."
          onChange={(newValue) => {
            item.notes = newValue;
          }}
        />
        <Input
          key={uid()}
          name="Conclusion"
          value={(item as any).conclusion}
          type="htmlarea"
          rows={4}
          placeholder="Champs de texte libre..."
          onChange={(newValue) => {
            (item as any).conclusion = newValue;
          }}
        />
      </div>
    ),
    onConfirm: async () => {
      item.creator = getUserId();
      await onConfirm(item);
      closeDrawer("historyTypeDrawer");
    },
  });
}
